import { CKLayoutHorizontal, CKLayoutHorizontalProps } from 'clearkit';
import { FC } from 'react';

export const ButtonContainer: FC<CKLayoutHorizontalProps> = ({
  as = 'footer',
  justifyContent = 'end',
  ...rest
}) => <CKLayoutHorizontal {...rest} as={as} justifyContent={justifyContent} />;
